import { action, extendObservable } from 'mobx';

const cache = {};

export default class ModelBase {
  constructor(id) {
    this._id = id;
  }

  static create(id) {
    if (!id) {
      throw new Error('No id specified');
    }

    if (!cache[this.className]) {
      cache[this.className] = {};
    }

    let object = cache[this.className][id];
    if (!object) {
      object = new this(id);
      cache[this.className][id] = object;
    }

    return object;
  }

  @action
  static fromJSON(id, json) {
    if (!id) {
      throw new Error('No id specified');
    }

    if (!json) {
      throw new Error('No JSON data specified');
    }
    var result = this.create(id);
    extendObservable(result, json);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/ModelBase.js